import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	z-index: 2;
	width: 100%;
	height: 100%;
	padding: 60px;
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	bottom: 60px;
	width: calc(100% - 120px);
	display: flex;
	justify-content: space-between;
`;

export { StyledContainer, StyledControlsContainer };
